import {FC} from 'react';
import {
  AudioItemControls,
  AudioItemControlsButton,
  AudioItemControlsLine,
  AudioItemControlsTime,
  AudioItemDate,
  AudioItemHead,
  AudioItemHive,
  AudioItemTag,
  AudioItemWrapper,
} from './styles';
import {COLORS} from 'shared/consts';
import {useAudioItem} from '../lib/useAudioItem';
import {format} from 'date-fns';

type AudioItemProps = {
  src: string;
  name: string;
  date: Date;
  tag?: string;
  hiveNumber?: number;
};
export const AudioItem: FC<AudioItemProps> = ({src, tag, hiveNumber, date}) => {
  const {
    audioElRef,
    lineRef,
    isPlayed,
    timeString,
    when,
    progressPrc,
    onPlayPauseButtonClick,
    onLoadedMetadata,
    onAudioPlay,
    onAudioPause,
    onAudioTimeUpdate,
    onProgressInputChange,
  } = useAudioItem();

  return (
    <AudioItemWrapper>
      <audio
        src={src}
        controls
        ref={audioElRef}
        onLoadedMetadata={onLoadedMetadata}
        onPlay={onAudioPlay}
        onPause={onAudioPause}
        onTimeUpdate={onAudioTimeUpdate}
      ></audio>

      <AudioItemHead>
        <AudioItemHive>{`Улей №${hiveNumber}`}</AudioItemHive>
        <span>•</span>
        <AudioItemDate>{format(date, 'dd.MM.yyyy в HH:mm')}</AudioItemDate>
        {tag && <AudioItemTag className="AudioItemTag">Риск роения</AudioItemTag>}
      </AudioItemHead>
      <AudioItemControls>
        <AudioItemControlsButton onClick={onPlayPauseButtonClick}>
          {isPlayed ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path
                fill={COLORS.ACCENT.DEFAULT}
                d="M15 18q-.402 0-.701-.299T14 17V7q0-.402.299-.701T15 6h1.5q.402 0 .701.299T17.5 7v10q0 .402-.299.701T16.5 18zm-7.5 0q-.402 0-.701-.299T6.5 17V7q0-.402.299-.701T7.5 6H9q.402 0 .701.299T10 7v10q0 .402-.299.701T9 18z"
              />
            </svg>
          ) : (
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.8706 8.90465L6.04088 2.66808C5.20634 2.18749 4.16797 2.79477 4.16797 3.76344V16.2366C4.16797 17.2052 5.20634 17.8125 6.04088 17.3319L16.8706 11.0954C17.7116 10.611 17.7116 9.38896 16.8706 8.90465Z"
                fill={COLORS.ACCENT.DEFAULT}
              />
            </svg>
          )}
        </AudioItemControlsButton>
        <AudioItemControlsLine
          ref={lineRef}
          style={
            {
              '--width': `${progressPrc}%`,
            } as React.CSSProperties
          }
        >
          {/* <i
            style={{
              "--left": `${progressPrc}%`
            } as React.CSSProperties}
          ></i> */}
          <input
            type="range"
            min={0}
            max={100}
            step={0.0001}
            value={progressPrc}
            onInput={onProgressInputChange}
          />
        </AudioItemControlsLine>
        <AudioItemControlsTime>{timeString}</AudioItemControlsTime>
      </AudioItemControls>
    </AudioItemWrapper>
  );
};
